<template>
  <div>
    <app-header />
    <div class="swiper-box healthycockpit" @mousewheel="rollScroll" style="float: left;width: 100%;height: 100vh;">
      <el-carousel sty height="100vh" trigger="click" :loop="false" direction="vertical" :autoplay="false" ref="carousel">
        <el-carousel-item key="1">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/healthycockpit/helhdiyim.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1380px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 560px;height: 148px;font-size: 56px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 74px;float: left;margin-top: 150px;margin-left: 50%;transform: translateX(-50%);">吾征健康智能驾舱系统</div>
              <!-- <img src="@/assets/images/cardiobrain/diyiimgre.png" alt="" style="width: 832px;height:750px;float: right;margin-top: 128px;" class="donghua"> -->
              <!--  <div style="width: 300px;height: 72px;font-size: 24px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 36px;float: left;margin-top: 40px;margin-right: 100px;">筛查、监护、预警、救援 <br>一体化的康养服务</div> -->
              <div style="width: 200px;height: 50px;background: #FFFFFF;box-shadow: 0px 2px 4px 0px #036BF7;border-radius: 30px;font-size: 16px;font-family: MicrosoftYaHei;color: #0D76FF;line-height: 50px;text-align: center;float: left;margin-top: 20%;cursor: pointer;cursor: pointer;position: absolute;bottom: 310px;left: 30px;" @click="cl = true">点击获取报价>></div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item key="2">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #fff;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 64px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:90px;text-align: center;">WHAT WE DO</div>
              <div style="width: 100%;float: left;margin-top: 180px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000;line-height: 52px;text-align: center;font-weight: 400;">吾征健康智能驾舱系统</div>
              </div>
              <div style="width: 100%;float: left;margin-top: 20px;">
                <div style="float: left;width: 520px;height: 540px;">
                  <img src="@/assets/images/healthycockpit/helh211.png" class="donghua" alt="" style="width: 520px;height:540px;float: right;">
                </div>
                <div style="float: left;width: 640px;height: 540px;background: #FFFFFF;border-radius: 10px;padding: 20px;">
                  <div style="width:600px;height: 200px;background: linear-gradient(90deg, #66A8FF 0%, #0D76FF 100%);border-radius: 20px;float: left;margin-left: 0;padding: 0 28px;box-sizing: border-box;">
                    <div style="width: 440px;float: left;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;margin-top: 20px;margin-left: 20px;">吾征健康智能驾舱系统</div>
                    <div style="width: 440px;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;margin-top: 10px;margin-left: 20px;">吾征基于大数据和人工能智能算法能力等优势，打造国内首个智能健康驾舱系统。健康驾舱中控面板SDK算法包接入车载环境传感器、驾驶员生理状态传感器，智能化采集人体健康、环境等数据，并对数据进行实时AI分析，生成驾舱健康风险评估报告。也可为驾驶员提供心脑等慢病健康与疾病风险评估与筛查、驾舱环境与疾病预警、支持接入E-Call系统实现24小时紧急救援等安全保障服务及健康管理服务，为驾驶员安全健康驾驶提供决策依据！
                    </div>
                  </div>
                  <div style="width: 100%;position: relative;top: 40%;">
                    <img src="@/assets/images/healthycockpit/helh22.png" alt="" style="position: absolute;top: 10px;left: -10px; width: 307px;height:229px;float: left;" class="donghua">
                    <img src="@/assets/images/healthycockpit/helh24.png" alt="" style="width:220px;height: 120px;background: #f7f7f7f;position: absolute;top: 220px;left: 30px;" class="donghua">
                    <img src="@/assets/images/healthycockpit/helh23.png" alt="" style="width: 345px;height:256px;position: absolute;top: 60px;right: -20px;" class="donghua">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>

        <el-carousel-item key="3">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #fff;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 64px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:90px;text-align: center;">TECHNICAL SUPERIORITY</div>
              <div style="width: 100%;float: left;margin-top: 180px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000;line-height: 52px;text-align: center;">技术优势</div>
                <!--  <div style="width: 100%;float: left;font-size: 16px;font-family: MicrosoftYaHei;color: #000000;line-height: 24px;margin-top: 40px;text-align: center;">“智能+车主健康+驾舱环境+救护”模式助力车企服务升级</div> -->
              </div>
              <div style="width: 100%;float: left;margin-top: 60px;">
                <div style="width: 300px;float: left;">
                  <div :class="li==1?'donghua1 into':'into'" class="into" @click="li=1" :style="{opacity:li==1?1:0.3}">
                    <span>“智能+健康+救护”<br>模式助力康养行业服务升级</span>
                    <span style="position: absolute;right: 30px; top: 0;z-index: 0;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: rgba(255, 255, 255,0.2);">1</span>
                  </div>
                  <div :class="li==2?'donghua1 into':'into'" @click="li=2" :style="{opacity:li==2?1:0.3,margin:'10px 0'}">
                    <span>中控面板SDK算法包，<br>国内首个健康智能驾舱黑科技</span>
                    <span style="position: absolute;right: 30px; top: 0;z-index: 0;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: rgba(255, 255, 255,0.2);">2</span>
                  </div>
                  <div :class="li==3?'donghua1 into':'into'" @click="li=3" :style="{opacity:li==3?1:0.3,marginBottom:'10px'}">
                    <span>AI认知算法，提供高标准认知计算<br>上亿条气象、病菌和疾病标注数据集<br>与近百万条疾病案例支撑</span>
                    <span style="position: absolute;right: 30px; top: 0;z-index: 0;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: rgba(255, 255, 255,0.2);">3</span>
                  </div>
                  <div :class="li==4?'donghua1 into':'into'" @click="li=4" :style="{opacity:li==4?1:0.3}">
                    <span>全时全域全方位救护，<br>一体化解决方案</span>
                    <span style="position: absolute;right: 30px; top: 0;z-index: 0;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: rgba(255, 255, 255,0.2);">4</span>
                  </div>
                </div>
                <div class="libox">

                  <div v-if="li==1" :class="li==1?'donghua1':''">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;line-height: 24px;margin-bottom: 30px;">“智能+车主健康+驾舱环境+救护”模式助力车企服务升级</div>
                    <div style="margin-bottom: 30px;">新一代车联网产品，除了注重多方位的安全防护外，健康需求愈加凸显。吾征AI智能驾舱更注重驾驶员与车内环境的整体协调配合，通过云、管、端，时刻守护驾驶员健康安全，智能驾舱将成为汽车智能化发展的点睛之笔。</div>
                    <div style="width: 170px;height: 240px;background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(13,118,255,0.2);border-radius: 4px;float: left; padding: 6px;box-sizing: border-box;">
                      <div style="width: 100%;height: 60px;background: linear-gradient(90deg, #0D76FF 0%, #66A8FF 100%);border-radius: 4px;text-align: center;line-height: 60px;color: #fff;">环境评估</div>
                      <div style="color: #999999;padding: 0px 4px;padding-top: 10px;">
                        吾征AI根据车内环境情况进行:
                      </div>
                      <div style="width: 100%;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 20px;padding: 0px 4px;">1.综合健康指数评估;<br />
                        2.环境与疾病风险评估;<br />
                        3.相关疾病知识图谱</div>
                    </div>
                    <div style="width: 170px;height: 240px;background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(13,118,255,0.2);border-radius: 4px;float: left;padding: 6px;box-sizing: border-box;margin-left: 16px;">
                      <div style="width: 100%;height: 60px;background: linear-gradient(90deg, #0D76FF 0%, #66A8FF 100%);border-radius: 4px;text-align: center;line-height: 60px;color: #fff;">动态分析</div>
                      <div style="color: #999999;padding: 0px 4px;padding-top: 10px;">
                        吾征AI可动态分析驾驶员的:
                      </div>
                      <div style="width: 100%;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 20px;padding: 0px 4px;">心率、心电、血压、血<br />
                        氧、呼吸、体动、心率变异性等多项指标。并对驾驶员状态进行客观评估。</div>
                    </div>
                    <div style="width: 170px;height: 240px;background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(13,118,255,0.2);border-radius: 4px;float: left;padding: 6px;box-sizing: border-box;margin-left: 16px;">
                      <div style="width: 100%;height: 60px;background: linear-gradient(90deg, #0D76FF 0%, #66A8FF 100%);border-radius: 4px;text-align: center;line-height: 60px;color: #fff;">智能预警</div>
                      <div style="width: 100%;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 20px;margin-top: 10px;padding: 0px 4px;">吾征Al可接入车内生物<br />
                        传感数据，Al算法会根<br />
                        据驾驶人的历史数据形<br />
                        成符合驾驶人员特征的<br />
                        预警方案。
                      </div>
                    </div>
                    <div style="width: 170px;height: 240px;background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(13,118,255,0.2);border-radius: 4px;float: left;padding: 6px;box-sizing: border-box;margin-left: 16px;">
                      <div style="width: 100%;height: 60px;background: linear-gradient(90deg, #0D76FF 0%, #66A8FF 100%);border-radius: 4px;text-align: center;line-height: 60px;color: #fff;">全国救援</div>
                      <div style="padding: 0px 4px;width: 100%;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 20px;margin-top: 10px;">全国全时120救援<br />
                        <!-- ● -->
                        <span style="width: 4px;height: 4px;background: #000;border-radius: 50%;float: left;margin-top: 7px;margin-right: 5px;"></span>
                        电话医疗急救指导
                        <br />
                        <span style="width: 4px;height: 4px;background: #000;border-radius: 50%;float: left;margin-top: 7px;margin-right: 5px;"></span> 协助安排住院<br />
                        <span style="width: 4px;height: 4px;background: #000;border-radius: 50%;float: left;margin-top: 7px;margin-right: 5px;"></span> 紧急信息通报<br />
                        <span style="width: 4px;height: 4px;background: #000;border-radius: 50%;float: left;margin-top: 7px;margin-right: 5px;"></span> 住院费用担保/垫付<br />
                        <span style="width: 4px;height: 4px;background: #000;border-radius: 50%;float: left;margin-top: 7px;margin-right: 5px;"></span> 病情跟踪与医疗监控<br />
                        <span style="width: 4px;height: 4px;background: #000;border-radius: 50%;float: left;margin-top: 7px;margin-right: 5px;"></span> 医疗单据收集
                      </div>
                    </div>
                  </div>


                  <div v-if="li==2" :class="li==2?'donghua1':''">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;line-height: 24px;margin-bottom: 30px;">中控面板SDK算法包，国内首个健康智能驾舱黑科技</div>
                    <div>
                      可通过车辆中控屏幕接入车载环境传感器、驾驶员生理状态传感器，并对数据进行实时Al分析，生成实时数据报告，并<br />将异常状态提供给中控大屏程序，为车主安全健康驾驶提供决策依据，如:健康空调方案、健康预警、疲劳休息提醒等。
                    </div>
                    <div style="width: 760px;height: 260px;background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(13,118,255,0.2);border-radius: 4px;float: left; padding: 6px;box-sizing: border-box;">
                    
                     <div style="width: 100%;clear: both;">
                       <div style="width: 32%;float: left;">
                        <div style="width: 100%;background-color: #F6FAFF;border-radius: 10px;margin-bottom: 10px;height: 120px;padding: 10px;">
                          <div style="background: linear-gradient(90deg, rgb(102, 168, 255) 0%, rgb(13, 118, 255) 100%);color: #fff;width: 20px;height: 100px;border-radius: 3px;text-align: center;line-height: 20px;padding: 10px 0px;float: left;"> 
                            车内环境 
                          </div>
                          <div style="float: left;padding-left: 10px;width: calc(100% - 20px);padding-top: 10px;color: #1890FF;">
                            车内温度、车内湿度
                            PM2.5、PM10、SO2、NO2、COO3甲醛、苯、丙酮、中国南方、中国北方等
                          </div>  
                        </div>

                        <div style="width: 100%;background-color: #F6FAFF;border-radius: 10px;margin-bottom: 10px;height: 120px;padding: 10px;">
                          <div style="background: linear-gradient(90deg, rgb(102, 168, 255) 0%, rgb(13, 118, 255) 100%);color: #fff;width: 20px;height: 100px;border-radius: 3px;text-align: center;line-height: 20px;padding: 10px 0px;float: left;"> 
                            司机数据 
                          </div>
                          <div style="float: left;padding-left: 10px;width: calc(100% - 20px);padding-top: 10px;color: #1890FF;">
                       
                            心率血压、血氧、心电、房颤、心率变异性(注意力、反应速度)
                          </div>  
                        </div>

                       </div>
                       <div style="width: 35%;float: left;">
                         <img src="@/assets/images/healthycockpit/helh321.png" style="width:256px;height: 178px;margin: 0 auto;display: block;">
                         <div style="text-align: center;background: linear-gradient(90deg, rgb(102, 168, 255) 0%, rgb(13, 118, 255) 100%);color: #fff;width: 70%;color: rgb(255, 255, 255);margin: 0 auto;height: 44px;line-height: 44px;border-radius: 10px;margin-top: 10px;">
                           吾征AI智能驾舱SDK
                         </div>
                      </div>
                       <div style="width: 33%;float: left;">

                        <div style="width: 100%;background-color: #F6FAFF;border-radius: 10px;margin-bottom: 10px;height: 120px;padding: 10px;">
                          <div style="width:100px;height: 100px;float: left;"> 
                             <img src="@/assets/images/healthycockpit/helh322.png" style="width:100px;height: 100px;background:#e7e7e7;margin: 0 auto;display: block;">
                          </div>
                          <div style="float: left;padding-left: 10px;width: calc(100% - 100px);padding-top: 10px;color: #1890FF;">
                           车内环境与致病情况分析，空调解决方案与日常建议

                          </div>  
                        </div>

                        <div style="width: 100%;background-color: #F6FAFF;border-radius: 10px;margin-bottom: 10px;height: 120px;padding: 10px;">
                          <div style="width:100px;height: 100px;float: left;"> 
                             <img src="@/assets/images/healthycockpit/helh323.png" style="width:100px;height: 100px;background:#e7e7e7;margin: 0 auto;display: block;">
                          </div>
                          <div style="float: left;padding-left: 10px;width: calc(100% - 100px);padding-top: 10px;color: #1890FF;">
                           动态监测与危机救援服务
                          </div>  
                        </div>
                       </div>
                     </div>

                    </div>
                  </div>



                  <div v-if="li==3" :class="li==3?'donghua1':''">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;line-height: 24px; margin-bottom: 60px;width: 100%;float: left;margin-top: 20px;">AI认知算法，提供高标准认知计算<br />上亿条气象、病菌和疾病标注数据集与近百万条疾病案例支撑</div>
                    <div style="width: 760px;height: 260px;background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(13,118,255,0.2);border-radius: 4px;float: left; padding: 6px;box-sizing: border-box;">
                      <div style="width: 50%;float: left;">
                        <div style="margin:20px auto;width: 60%;height: 60px;background: linear-gradient(90deg, #0D76FF 0%, #66A8FF 100%);border-radius: 4px;text-align: center;line-height: 60px;color: #fff;">车主动态健康监测和预警</div>
                        <div style="width: 100%;font-size: 14px;font-family: MicrosoftYaHei;color: #1890FF;line-height: 22px;margin-top: 20px;text-align: center;padding:0;text-align: left;padding-left: 16%;">7年大数据分析+语义认知算法技术加持,<br />
                          提供高标准认知计算;改进国际先进的弗明<br />
                          心脑风险算法，构建中国人的心脑发病风险<br />
                          模型;心脑精准预警模型，定制人人不同的<br />
                          预警方案。
                        </div>
                      </div>
                      <div style="width: 50%;float: left;">
                        <div style="margin:20px auto;width: 60%;height: 60px;background: linear-gradient(90deg, #0D76FF 0%, #66A8FF 100%);border-radius: 4px;text-align: center;line-height: 60px;color: #fff;">驾舱环境与疾病Al预警分析</div>
                        <div style="width: 100%;font-size: 14px;font-family: MicrosoftYaHei;color: #1890FF;line-height: 22px;margin-top: 20px;text-align: center;padding:0;text-align: left;padding-left: 16%;">
                          系统通过归集和人工预处理近百万条气象与<br />
                          疾病案例分析数据，以及.上亿条基于气象、<br />
                          病菌和疾病标注数据集，运用认知智能和大<br />
                          数据技术，实现驾舱温度、湿度等信息变化<br />
                          进行“病菌危险指数”、“干湿度指数”、“呼<br />
                          吸道疾病发病指数”等六十多种指数解读
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="li==4" :class="li==4?'donghua1':''">
                    <div style="font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;line-height: 24px;margin-bottom: 30px;">全时全域全方位救护，一体化解决方案</div>
                    <div style="width: 760px;height: 110px;float: left;box-sizing: border-box;">
                      <div style="width: 100%;float: left;">
                        <div style="width: 100%;font-size: 14px;font-family: MicrosoftYaHei;line-height: 22px;margin-top: 20px;text-align: center;padding:0;text-align: left;">
                          当车辆发生事故或车主数据异常时，中控系统会自动判断是否需要进行救援，并通过中控系统进行语音提醒和确认。如<br />
                          果车主回答“需要救援”，系统会自动获取车辆的位置和信息，并立即启动紧急救援服务，第一时间保护车主的生命安<br />
                          全。如果车主回答“不需要救援”，系统会继续监测车主的生理信号和车辆状态，并在需要时提醒车主。</div>
                      </div>
                    </div>
                    <div>
                      <img src="@/assets/images/healthycockpit/helh34.png" alt="" style="width: 682px;height:212px;z-index: 1;">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>

        <el-carousel-item key="4">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background-color: #F6FAFF;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 64px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #E8F2FF;line-height: 106px;position: absolute;z-index: -1;left: 0;top:60px;text-align: center;">OUR SERVICE</div>
              <div style="width: 100%;float: left;margin-top: 120px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000;line-height: 52px;text-align: center;">我们的服务</div>
              </div>
              <div style="width: 100%;float: left;margin-top: 20px;">
                <div style="width: 100%;float: left;border-bottom: 2px solid rgba(13, 118, 255, 0.1);">
                  <div style="width: 33%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;cursor: pointer;">
                    <span class="inli" :style="{borderBottom: inli==1?'2px solid  #0D76FF':'2px solid  rgba(13, 118, 255, 0)',color:inli==1?'#0D76FF':'#000000','font-weight':'400'}" @click="inli=1">环境健康预警</span>
                  </div>
                  <div style="width: 33%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;cursor: pointer;">
                    <span style="width: 220px;display: inline-block;padding-bottom: 20px;box-sizing: border-box;text-align: center;border-bottom: 2px solid  #0D76FF;" class="inli" :style="{borderBottom: inli==2?'2px solid  #0D76FF':'2px solid  rgba(13, 118, 255, 0)',color:inli==2?'#0D76FF':'#000000','font-weight':'400'}" @click="inli=2">车主健康预警</span></div>


                     <div style="width: 33%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #0D76FF;cursor: pointer;">
                    <span style="width: 220px;display: inline-block;padding-bottom: 20px;box-sizing: border-box;text-align: center;border-bottom: 2px solid  #0D76FF;" class="inli" :style="{borderBottom: inli==3?'2px solid  #0D76FF':'2px solid  rgba(13, 118, 255, 0)',color:inli==3?'#0D76FF':'#000000','font-weight':'400'}" @click="inli=3">驾舱健康风险评估报告</span></div>


                </div>


                <div v-if="inli==1" style="width: 100%;clear: both;">
                  <div style="width: 100%;padding: 20px;">
                    <span style="font-size: 20px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #0D76FF;line-height: 24px;">环境健康预警</span>
                    <span style="font-size: 14px;font-family: PingFang-SC-Regular, PingFang-SC;font-weight: 400;color: #0D76FF;line-height: 24px;">驾舱环境与疾病AI预警分析，提供有效空调解决方案</span>
                  </div>
                  <div style="font-size: 14px;font-family: PingFang-SC-Regular, PingFang-SC;font-weight: 400;color: #000000;line-height: 22px;padding-left: 20px;">
                    吾征AI智能驾舱通过归集和人工预处理近百万条气象与疾病案例分析数据，以及上亿条基于气象、病菌和疾病标注数据集，通过车载环境传感器获取车内环境数据，如温湿度、空气成分、物理性污染物、化学性污染物等信息，自动推导、预测出普通疾病的风险指数以及致病病菌生长、繁殖风险，实现了驾舱温度、湿度等信息变化进行“病菌危险指数”、“干湿度指数”、“呼吸道疾病发病指数”等六十多种指数解读，并提供相应的车内环境与致病情况分析、空调解决方案与日常建议。为车主提供全方位的安全保障。
                  </div>
                  <div>
                    <!-- helh411.png -->
                    <img src="@/assets/images/healthycockpit/helh413.png" alt="" style="width: 100%;height:410px;float: left;margin-top: 20px;" :class="inli==1?'donghua1 donghua':'donghua'">
                  </div>
                </div>


                <div v-if="inli==2" style="width: 100%;clear: both;">
                   <div style="width: 100%;padding: 20px;">
                    <span style="font-size: 20px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #0D76FF;line-height: 24px;">车主健康预警</span>
                    <span style="font-size: 14px;font-family: PingFang-SC-Regular, PingFang-SC;font-weight: 400;color: #0D76FF;line-height: 24px;">驾舱环境与疾病AI预警分析，提供有效空调解决方案</span>
                  </div>
                  <div style="font-size: 14px;font-family: PingFang-SC-Regular, PingFang-SC;font-weight: 400;color: #000000;line-height: 22px;padding-left: 20px;">
                    吾征AI智能驾舱通过归集和人工预处理近百万条气象与疾病案例分析数据，以及上亿条基于气象、病菌和疾病标注数据集，通过车载环境传感器获取车内环境数据，如温湿度、空气成分、物理性污染物、化学性污染物等信息，自动推导、预测出普通疾病的风险指数以及致病病菌生长、繁殖风险，实现了驾舱温度、湿度等信息变化进行“病菌危险指数”、“干湿度指数”、“呼吸道疾病发病指数”等六十多种指数解读，并提供相应的车内环境与致病情况分析、空调解决方案与日常建议。为车主提供全方位的安全保障。
                  </div>
                  <div>
                    <img src="@/assets/images/healthycockpit/helh423.png" alt="" style="width: 100%;height:410px;float: left;margin-top: 20px;" :class="inli==1?'donghua1 donghua':'donghua'">
                  </div>
                </div>


                

                <div v-if="inli==3" style="width: 100%;clear: both;">
                   <div style="width: 100%;padding: 20px;">
                    <span style="font-size: 20px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #0D76FF;line-height: 24px;">驾舱健康风险评估报告</span>
                    <span style="font-size: 14px;font-family: PingFang-SC-Regular, PingFang-SC;font-weight: 400;color: #0D76FF;line-height: 24px;">可根据车企需求，实现中控台展示、扫码展示或线下展示 </span>
                  </div>
                  <div style="font-size: 14px;font-family: PingFang-SC-Regular, PingFang-SC;font-weight: 400;color: #000000;line-height: 22px;padding-left: 20px;">
                    健康驾舱中控面板SDK算法包接入车载环境传感器、驾驶员生理状态传感器，智能化采集人体健康、环境等数据，并对数据进行实时AI分析，生成驾舱健康风险评估报告。
                  </div>
                  <div style="font-size: 14px;font-family: PingFang-SC-Regular, PingFang-SC;font-weight: 400;color: #000000;line-height: 22px;padding-left: 20px;">
                    <div style="width: 110px;height: 30px;background: linear-gradient(270deg, #66A8FF 0%, #4E9BFF 27%, #0D76FF 100%);border-radius: 4px;line-height: 30px;color: #FFF;text-align: center;float: left;">
                      报告内容包括：
                    </div>
                    <div style="width: calc(100% - 110px);float: left;color: #1890FF;font-size: 12px;padding-top: 4px;">
                      <span style="margin: 0 10px;float: left;">
                        <span style="width: 4px;height: 4px;background: #1890FF;border-radius: 50%;float: left;margin-top: 10px;margin-right: 5px;"></span>
                        电话医疗急救指导
                      </span>
                       <span style="margin: 0 10px;float: left;">
                        <span style="width: 4px;height: 4px;background: #1890FF;border-radius: 50%;float: left;margin-top: 10px;margin-right: 5px;"></span>
                        综合风险分析
                      </span>
                       <span style="margin: 0 10px;float: left;">
                        <span style="width: 4px;height: 4px;background: #1890FF;border-radius: 50%;float: left;margin-top: 10px;margin-right: 5px;"></span>
                        疾病风险隐患
                      </span>
                       <span style="margin: 0 10px;float: left;">
                        <span style="width: 4px;height: 4px;background: #1890FF;border-radius: 50%;float: left;margin-top: 10px;margin-right: 5px;"></span>
                        保险推荐方案
                      </span>
                       <span style="margin: 0 10px;float: left;">
                        <span style="width: 4px;height: 4px;background: #1890FF;border-radius: 50%;float: left;margin-top: 10px;margin-right: 5px;"></span>
                        驾驶员状态总览
                      </span>

                       <span style="margin: 0 10px;float: left;">
                        <span style="width: 4px;height: 4px;background: #1890FF;border-radius: 50%;float: left;margin-top: 10px;margin-right: 5px;"></span>
                        车内环境指标分析
                      </span>

                       <span style="margin: 0 10px;float: left;">
                        <span style="width: 4px;height: 4px;background: #1890FF;border-radius: 50%;float: left;margin-top: 10px;margin-right: 5px;"></span>
                        驾驶员实时监测数据
                      </span>


                      <span style="margin: 0 10px;float: left;">
                        <span style="width: 4px;height: 4px;background: #1890FF;border-radius: 50%;float: left;margin-top: 10px;margin-right: 5px;"></span>
                        健康饮食和运动建议
                      </span>
                       
                         
                    </div>
                  </div>
                  <div>
                    <img src="@/assets/images/healthycockpit/helh433.png" alt="" style="width: 100%;height:410px;float: left;margin-top: 20px;" :class="inli==1?'donghua1 donghua':'donghua'">
                  </div>
                </div>

                <div style="width: 100%;clear: both;">
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
       
        
        <el-carousel-item key="5">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background: linear-gradient(130deg, #387AEE 0%, #66A8FF 100%);"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;font-size: 80px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;line-height: 106px;position: absolute;z-index: -1;left: 0;top:90px;text-align: center;opacity: 0.1;">LEARN MORE</div>
              <div style="width: 100%;float: left;margin-top: 140px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;line-height: 52px;text-align: center;">了解更多</div>
                <div style="width: 100%;float: left;margin-top: 200px;">
                  <!--          <div style="width: 380px;height: 300px;background: #90B7F7;border-radius: 10px;float: left;margin-left: 0;">
                    <div style="width: 380px;height: 300px;background: #fff;border-radius: 10px;float: left;margin-left: -10px;margin-top: -10px;padding: 40px 30px;box-sizing: border-box;">
                      <div style="width: 100%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">更多文章</div>
                      <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #0D76FF;line-height: 22px;margin-top: 30px; text-decoration: underline; ">◆ 吾征推出心脑血管AI健康管理计划，赋能社区居民美好生活<br><br> ◆ 后疫情时代需要监测吗？这些人真需要！<br><br> ◆ 推动心脑血管疾病防治工程建设，助力心脑辅助诊疗迈上新台阶。</div>
                    </div>
                  </div> -->
                  <div style="width: 380px;height: 300px;background: #90B7F7;border-radius: 10px;float: left;margin-left: 180px;">
                    <div style="width: 380px;height: 300px;background: #fff;border-radius: 10px;float: left;margin-left: -10px;margin-top: -10px;padding: 40px 30px;box-sizing: border-box;">
                      <div style="width: 100%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">资料下载</div>
                       <div style="float: left;width: 200px;height: 60px;background: linear-gradient(318deg, #66A8FF 0%, #0D76FF 100%);border-radius: 10px;font-size: 14px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 60px;text-align: center;margin-left:70px ;margin-top: 74px;"> <a class="aquchu" href="https://ftp.infobigdata.com/healthIntelligentCockpitProductInformation.pdf" target="_blank">点击下载资料</a> </div>
                    </div>
                  </div>
                  <div style="width: 380px;height: 300px;background: #90B7F7;border-radius: 10px;float: left;margin-left: 100px;">
                    <div style="width: 380px;height: 300px;background: #fff;border-radius: 10px;float: left;margin-left: -10px;margin-top: -10px;padding: 40px 30px;box-sizing: border-box;">
                      <div style="width: 100%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">获取报价</div>
                      <div style="float: left;width: 200px;height: 60px;background: linear-gradient(318deg, #66A8FF 0%, #0D76FF 100%);border-radius: 10px;font-size: 14px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;text-align: center;margin-left:70px ;margin-top: 74px;padding: 10px 0;box-sizing: border-box;cursor: pointer;"  @click="cl = true">点击获取<br>详细方案及报价</div>
                    </div>
                  </div>
                  <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 19px;text-align: center;margin-top: 160px;">© Copyright © 2017-2021 中润普达 - 京ICP备2021002262号-1</div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
               <!-- <app-footer /> -->
    <div style="width: 100%;height: 100vh;position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;z-index: 999;
    background: rgba(0, 0, 0, 0.8);" v-if="cl" @click="cl = false">
      <img src="@/assets/images/cardiobrain/erweima.jpg" alt="" style="width: 10vw;height: 10vw;margin:0 45vw;margin-top:30vh;">
      <div style="width: 100%;text-align: center;font-size: 16px;color: #fff;margin-top: 10px;">扫码添加获取详细方案及报价</div>
    </div>
  </div>
</template>
<script>
import header from '@/components/header'
import footer from '@/components/footer'

export default {
  data() {
    return {
       cl: false,
      inli: 1,
      li: 1,
      zoucl: true,
      scrollBox: { time: 300 },

    }
  },
  mounted() {


  },
  methods: {
    zouni() {
      var myVideo = document.getElementById("video");
      if (myVideo.paused) {
        myVideo.play();
        this.zoucl = false;
      } else {
        myVideo.pause();
        this.zoucl = true;

      }

    },
    rollScroll(event) {
      console.log(event)
      let _that = this;
      let scrollVal = event.wheelDelta || event.detail;
      if (_that.scrollBox.time) {
        clearTimeout(_that.scrollBox.time)
      }
      _that.scrollBox.time = setTimeout(() => {
        scrollVal > 0 ? _that.$refs.carousel.prev() : _that.$refs.carousel.next();
      }, 300);
    },
  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
}

</script>
<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.swiper-box .el-carousel__indicator--vertical .el-carousel__button {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #C6E0FF;
  border: none;
  box-sizing: content-box;
  border: 2px solid rgba(0, 0, 0, 0);

}

.swiper-box .el-carousel__indicator.is-active button {
  background-color: #0D76FF;
  border: 2px solid #C6E0FF;
}

.libox {
  width: 890px;
  height: 500px;
  overflow: hidden;
  float: left;
  padding: 80px 76px;
  box-sizing: border-box;
  margin-left: 10px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #000000;
  line-height: 22px;
  background: url(../assets/images/cardiobrain/beij.png) 0 0 no-repeat;
}

.healthycockpit .into {
  width: 100%;
  height: 120px;
  background: linear-gradient(90deg, #0D76FF 0%, #66A8FF 100%);
  border-radius: 4px;
  float: left;
  padding: 36px 20px 0px 20px;
  box-sizing: border-box;
  position: relative;
  font-size: 16px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #FFFFFF;
  cursor: pointer;
}

.inli {
  width: 220px;
  display: inline-block;
  padding-bottom: 20px;
  box-sizing: border-box;
  text-align: center;
}

.tuingo {
  width: 570px;
  height: 300px;
  float: left;
  padding: 45px;
  box-sizing: border-box;
  margin-bottom: 60px;
  color: #fff;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #FFFFFF;
  cursor: pointer;


}

.tuingo1 {
  background: url(../assets/images/cardiobrain/cjin1.png) 0 0 no-repeat;
  margin-right: 60px;

}

.tuingo2 {
  background: url(../assets/images/cardiobrain/cjin2.png) 0 0 no-repeat;

}

.tuingo3 {
  background: url(../assets/images/cardiobrain/cjin3.png) 0 0 no-repeat;
  margin-right: 60px;

}

.tuingo4 {
  background: url(../assets/images/cardiobrain/cjin4.png) 0 0 no-repeat;

}

.donghua {
  -webkit-transition: -webkit-transform 1s ease;
  /* For Safari 3.1 to 6.0 */
  transition: transform 1s ease;
}

.donghua:hover {
  -ms-transform: scale(1.1);
  /* IE 9 */
  -webkit-transform: scale(1.1);
  /* Safari */
  transform: scale(1.1);
  /* 标准语法 */
}

.donghua1 {
  animation: myfirst 2s;
  -webkit-animation: myfirst 2s;
  /* Safari and Chrome */
}

@keyframes myfirst {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-webkit-keyframes myfirst

/* Safari and Chrome */
  {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
.aquchu {
  text-decoration: none;
  color: #fff;
}

.aquchu:hover,
.aquchu:visited,
.aquchu:link,
.aquchu:active {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/healthycockpit.vue